import { Inject, Component, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";
import { ValorizationItemAmount } from "../../../../model/valorization-item";
import { NotificationToastService } from "../../../../services/notification-toast.service";
import { PracticeService } from "src/app/services/practice.service";

export interface ValorizationItemAddSetInsumoDialogComponentRequest {
  item: ValorizationItemAmount;
  planId: number;
  centerId?: number;
  existingSetSupplieIds: number[];
}

@Component({
  selector: "app-valorization-item-add-set-insumo-dialog",
  templateUrl: "valorization-item-add-set-insumo-dialog.component.html",
})
export class ValorizationItemAddSetInsumoDialogComponent implements OnInit {
  loading: boolean;

  displayedColumns: string[] = ["select", "name", "id"];
  dataSource: any[] = [];
  selection = new Set<number>();

  constructor(
    public dialogRef: MatDialogRef<ValorizationItemAddSetInsumoDialogComponent>,
    private notificationToastService: NotificationToastService,
    private practiceService: PracticeService,
    @Inject(MAT_DIALOG_DATA)
    public data: ValorizationItemAddSetInsumoDialogComponentRequest
  ) {}

  async ngOnInit() {
    await this.loadInfo();
  }

  private async loadInfo() {
    try {
      this.loading = true;
      const items =
        await this.practiceService.getAditionalPracticeAndSetSuppliesReservation(
          [
            this.data.item.ValorizationItem.MedicalAppointmentProcedure
              .PracticeRegionAditionalId
              ? this.data.item.ValorizationItem.MedicalAppointmentProcedure
                  .PracticeRegionAditionalId
              : this.data.item.ValorizationItem.MedicalAppointmentProcedure
                  .PracticeRegionId,
          ],
          this.data.planId,
          this.data.centerId
        );

      if (items.length > 0) {

        this.dataSource = Array.from(
          new Map(
            items[0].SetsSuppliesReservation.filter(
              (item) =>
                item.AgreementPriceId &&
                item.PracticeRegionSetSuppliesId !== 0 &&
                !this.data.existingSetSupplieIds.includes(item.Id)
            ).map((item) => [
              item.AgreementPriceId,
              { Id: item.AgreementPriceId, Name: item.Name },
            ])
          ).values()
        );
      }
    } catch (err) {
      this.notificationToastService.error(
        JSON.stringify(err.error),
        "Valorización"
      );
    } finally {
      this.loading = false;
    }
  }

  toggleSelection(id: number): void {
    if (this.selection.has(id)) {
      this.selection.delete(id);
    } else {
      this.selection.add(id);
    }
  }

  save(): void {
    const selectedItems = this.dataSource.filter((item) =>
      this.selection.has(item.Id)
    );

    if (selectedItems.length === 0) {
      this.notificationToastService.error(
        "Debe seleccionar al menos un insumo",
        "Valorización"
      );
      return;
    }

    this.dialogRef.close(selectedItems.map((item) => item.Id));
  }

  onNoClick(): void {
    this.dialogRef.close(false);
  }
}
